import React from 'react';
import { AlertCircle, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
const instructions = ['For grey, use CMYK 0,0,0,K only. Adjust grey using the K slider only.', 'Using other CMYK values will result in incorrect grey output.', 'For rich black, use RGB 0,0,0.', 'We print exactly what you upload. Colors are not adjusted.', 'Submit artwork in the exact colors you want printed.'];
export function ArtworkInstructions() {
  return <section className="py-16 bg-atomic-black" data-id="element-1">
      <div className="container mx-auto px-4 md:px-6" data-id="element-2">
        <div className="max-w-3xl mx-auto" data-id="element-3">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-atomic-charcoal rounded-xl p-8 md:p-10 border border-white/10" data-id="element-4">
            {/* Heading */}
            <div className="flex items-center gap-3 mb-6" data-id="element-5">
              <div className="w-10 h-10 rounded-lg bg-atomic-green/10 flex items-center justify-center text-atomic-green border border-atomic-green/20" data-id="element-6">
                <CheckCircle size={20} data-id="element-7" />
              </div>
              <h3 className="text-2xl font-bold text-white" data-id="element-8">
                Important Artwork Notes
              </h3>
            </div>

            {/* Instructions List */}
            <ul className="space-y-4 mb-8" data-id="element-9">
              {instructions.map((instruction, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-3 text-gray-300 leading-relaxed" data-id="element-10">
                  <span className="text-atomic-green mt-1 shrink-0" data-id="element-11">•</span>
                  <span data-id="element-12">{instruction}</span>
                </motion.li>)}
            </ul>

            {/* Warning Callout */}
            <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg p-4 flex items-start gap-3" data-id="element-13">
              <AlertCircle className="text-amber-500 shrink-0 mt-0.5" size={20} data-id="element-14" />
              <div data-id="element-15">
                <p className="text-amber-200 font-medium text-sm" data-id="element-16">
                  Warning: Color accuracy depends entirely on the file you
                  upload.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}